// Thin REST client for the Template Engine server.
const API_BASE_URL = (process.env.REACT_APP_SERVER_URL || '').replace(/\/$/, '');

export const apiUrl = (path) => `${API_BASE_URL}${path}`;

async function handle(res) {
  if (!res.ok) {
    let detail = '';
    try { detail = (await res.json()).error || ''; } catch (_) {}
    throw new Error(detail || `Request failed (${res.status})`);
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  // Templates
  listTemplates: (userId) =>
    fetch(apiUrl(`/api/templates?userId=${encodeURIComponent(userId || '')}`)).then(handle),
  getTemplate: (id) => fetch(apiUrl(`/api/templates/${id}`)).then(handle),
  createTemplate: (body) =>
    fetch(apiUrl('/api/templates'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(handle),
  updateTemplate: (id, body) =>
    fetch(apiUrl(`/api/templates/${id}`), {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(handle),
  deleteTemplate: (id) =>
    fetch(apiUrl(`/api/templates/${id}`), { method: 'DELETE' }).then(handle),
  uploadTemplate: (file, userId, name) => {
    const fd = new FormData();
    fd.append('file', file);
    if (userId) fd.append('userId', userId);
    if (name) fd.append('name', name);
    return fetch(apiUrl('/api/templates/upload'), { method: 'POST', body: fd }).then(handle);
  },

  // Devices
  listDevices: (userId) =>
    fetch(apiUrl(`/api/devices?userId=${encodeURIComponent(userId || '')}`)).then(handle),
  unclaimDevice: (deviceUUID, userId) =>
    fetch(apiUrl('/api/device/unclaim'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ deviceUUID, userId })
    }).then(handle),

  // Pairing
  claimPairing: (token, userId, userEmail) =>
    fetch(apiUrl('/api/pair/claim'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, userId, userEmail })
    }).then(handle),

  // Floor plans
  listFloorplans: (userId) =>
    fetch(apiUrl(`/api/floorplans?userId=${encodeURIComponent(userId || '')}`)).then(handle),
  createFloorplan: (name, userId) =>
    fetch(apiUrl('/api/floorplans'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, userId })
    }).then(handle),
  uploadFloorplanImage: (id, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return fetch(apiUrl(`/api/floorplans/${id}/image`), { method: 'POST', body: fd }).then(handle);
  },
  saveFloorplanDevices: (id, placements) =>
    fetch(apiUrl(`/api/floorplans/${id}/devices`), {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ placements })
    }).then(handle),
  deleteFloorplan: (id) =>
    fetch(apiUrl(`/api/floorplans/${id}`), { method: 'DELETE' }).then(handle),

  // Data sources
  listDataSources: (userId) =>
    fetch(apiUrl(`/api/data-sources?userId=${encodeURIComponent(userId || '')}`)).then(handle),
  getDataSource: (id) => fetch(apiUrl(`/api/data-sources/${id}`)).then(handle),
  createDataSource: (body) =>
    fetch(apiUrl('/api/data-sources'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(handle),
  updateDataSource: (id, body) =>
    fetch(apiUrl(`/api/data-sources/${id}`), {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(handle),
  deleteDataSource: (id) =>
    fetch(apiUrl(`/api/data-sources/${id}`), { method: 'DELETE' }).then(handle),
};
